define((require) => {
    "use strict";

    const ContentQuery  = require("data/ContentQuery");
    const Enum = require("shared/util/Enum");

    const sorting = {
        LAST_UPLOADED: {
            name: "lastUploaded",
            title: "Last Uploaded",
            query: ContentQuery.sort().field("createdAt")
        },
        ALPHABETICAL: {
            name: "alphabetical",
            title: "Alphabetical",
            query: ContentQuery.sort().field("name", "Ascending")
        },
        MOST_USED: {
            name: "mostUsed",
            title: "Most Used",
            query: ContentQuery.sort().field("timesUsed")
        },
        MOST_VIEWED: {
            name: "mostViewed",
            title: "Most Viewed",
            query: ContentQuery.sort().field("measureData.totalViews")
        }
    };

    return Enum.create("ImageLibrarySortingEnum", "name", sorting, {
        without(...items) {
            return this.all().filter((sortingOption) => items.indexOf(sortingOption) === -1);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/imageLibrary/ImageLibrarySortingEnum.js